var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-body" }, [
    _c("fieldset", { staticClass: "border" }, [
      _vm.description
        ? _c("legend", { staticClass: "border" }, [
            _c("b", [_vm._v(_vm._s(_vm.description.title))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "text-left" }, [
        _vm.description
          ? _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.replaceHTMLSellerInfo(_vm.description.content)
                )
              }
            })
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76ee6bc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76ee6bc2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/deliveryRequests/Top.vue
// module id = null
// module chunks = 